// subjectSlice.js
import { createSlice } from "@reduxjs/toolkit"

const subjectSlice = createSlice({
  name: "student/subject",
  initialState: {
    isLoading: false,
    subject: null,
    students: null,
    periodsOptions: [],
  },
  reducers: {
    onReadData: state => {
      state.isLoading = true
    },
    onReadDataSuccess: (state, action) => {


      state.isLoading = false
      state.subject = action.payload.subject
      state.students = action.payload.students
      state.periodsOptions = action.payload.periodsOptions

    },
    handleSelectSubject: (state, action) => {
      state.subject = action.payload
    },
    handleSelectSubjectChangeProperty: (state, action) => {
      const { fieldName, newValue } = action.payload
      state.subject[fieldName] = newValue
    },
  },
})

export const {
  onReadData,
  onReadDataSuccess,
  handleSelectSubject,
  handleSelectSubjectChangeProperty,
} = subjectSlice.actions
export default subjectSlice.reducer

export const selectCurrentSubjectStudent = state => state.student.subject
export const selectCurrentSubject = state => state.student.subject.subject
export const selectCurrentStudents = state => state.student.subject.students
export const selectCurrentIsloading = state => state.student.subject.isLoading
